import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocEnableNotifications(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M82.206 21.625H28.371a7.69 7.69 0 0 0-7.691 7.69h53.835a7.69 7.69 0 0 1 7.691-7.69Z"
        fill="#CCD5E1"
      />
      <path d="M89.897 83.92V37.008l-53.835-7.691V76.23l53.835 7.69Z" fill="#fff" />
      <path
        d="M36.062 90.842a7.69 7.69 0 0 0 7.69 7.691h53.836a7.69 7.69 0 0 1-7.691-7.69V29.315a7.69 7.69 0 0 0-7.69-7.691H28.37a7.69 7.69 0 0 1 7.69 7.69v61.527Z"
        fill="#F1F5F9"
      />
      <path
        d="M43.752 98.533h53.836a7.691 7.691 0 0 0 7.691-7.69H51.443a7.69 7.69 0 0 1-7.69 7.69Z"
        fill="#CCD5E1"
      />
      <path
        d="M50.643 90.842a.8.8 0 0 1 1.6 0 8.492 8.492 0 0 1-8.49 8.491.8.8 0 0 1 0-1.6 6.89 6.89 0 0 0 6.89-6.89Z"
        fill="#0F172A"
      />
      <path
        d="M80.868 37.807a.8.8 0 0 0 0-1.6H70.102a.8.8 0 0 0 0 1.6h10.767Zm0 7.69a.8.8 0 0 0 0-1.6H70.102a.8.8 0 0 0 0 1.6h10.767Zm0 7.691a.8.8 0 0 0 0-1.6H70.102a.8.8 0 0 0 0 1.6h10.767Zm0 7.69a.8.8 0 0 0 0-1.599h-35.89a.8.8 0 1 0 0 1.6h35.89Zm0 7.691a.8.8 0 0 0 0-1.6h-35.89a.8.8 0 0 0 0 1.6h35.89Zm0 7.692a.8.8 0 0 0 0-1.6h-35.89a.8.8 0 0 0 0 1.6h35.89Zm0 7.69a.8.8 0 0 0 0-1.6h-35.89a.8.8 0 1 0 0 1.6h35.89Z"
        fill="#B3C0D0"
      />
      <path
        d="M54.135 40.052c.431 0 .781.341.798.769h4.2l.115.008a.8.8 0 0 1 .61.452l.001.002.003.007.014.029.05.106a80.842 80.842 0 0 1 .712 1.585c.194.45.392.927.544 1.333.075.203.142.398.192.57.042.144.098.356.098.553a2.339 2.339 0 0 1-4.664.24l-.012-.24c0-.197.056-.41.098-.554.05-.17.117-.366.192-.569.151-.407.35-.884.545-1.333.088-.203.178-.402.262-.589h-2.958v6.091h.353a.8.8 0 1 1 0 1.6h-2.307a.8.8 0 1 1 0-1.6h.354v-6.09h-2.958c.083.186.175.385.263.588.194.45.392.927.544 1.333.075.203.142.398.192.57.042.144.098.356.098.553a2.339 2.339 0 1 1-4.676 0c0-.197.055-.41.097-.554.05-.17.117-.366.193-.569.151-.407.35-.884.545-1.333.195-.451.39-.884.535-1.202l.177-.383.049-.106.013-.029.004-.007v-.002h.001l.056-.101a.8.8 0 0 1 .668-.36h4.2a.799.799 0 0 1 .799-.768ZM49.1 43.645c-.19.44-.376.887-.513 1.256-.069.184-.122.34-.156.458-.042.144-.035.16-.035.107a.738.738 0 0 0 1.473.076l.003-.055a1.745 1.745 0 0 0-.033-.128 6.907 6.907 0 0 0-.156-.458 27.67 27.67 0 0 0-.513-1.256l-.035-.08-.035.08Zm9.998 0c-.19.44-.376.887-.513 1.256-.069.184-.122.34-.156.458-.042.144-.035.16-.035.107a.738.738 0 0 0 1.473.076l.003-.055a1.804 1.804 0 0 0-.033-.128 6.976 6.976 0 0 0-.156-.458 27.44 27.44 0 0 0-.513-1.256l-.035-.08-.035.08Z"
        fill="#80CCB5"
      />
      <path
        d="M34.52 43.154v-13.93c0-3.799-2.897-6.8-6.376-6.8a.8.8 0 1 1 0-1.599c4.447 0 7.976 3.804 7.976 8.399v13.93a.8.8 0 0 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M25.564 49.743a2.912 2.912 0 0 1 3.605-1.99l19.582 5.649a2.911 2.911 0 0 1 1.99 3.604L40.249 93.372a2.911 2.911 0 0 1-3.604 1.99l-19.582-5.649a2.911 2.911 0 0 1-1.99-3.604l10.491-36.366Z"
        fill="#00664F"
      />
      <path
        d="m37.089 93.826-.444 1.536-19.582-5.649.443-1.537 19.583 5.65Zm1.623-.897 10.492-36.367c.2-.695-.2-1.422-.897-1.623l-19.582-5.65a1.312 1.312 0 0 0-1.623.897L16.61 86.552c-.2.696.2 1.423.896 1.624l-.443 1.537-.142-.045a2.911 2.911 0 0 1-1.886-3.414l.038-.145 10.492-36.366a2.911 2.911 0 0 1 3.604-1.99l19.582 5.649.142.045a2.912 2.912 0 0 1 1.848 3.559L40.249 93.372l-.045.143A2.912 2.912 0 0 1 36.79 95.4l-.145-.038.444-1.536c.695.2 1.422-.201 1.623-.897Z"
        fill="#00664F"
      />
      <path
        d="M27.243 50.227a1.164 1.164 0 0 1 1.442-.796l7.552 2.179-.16.56a1.747 1.747 0 0 0 1.193 2.162l1.12.323a1.747 1.747 0 0 0 2.162-1.194l.161-.56 7.553 2.179c.618.178.975.824.796 1.442L38.571 92.888a1.165 1.165 0 0 1-1.442.796l-19.581-5.65a1.165 1.165 0 0 1-.797-1.441l10.492-36.366Z"
        fill="#fff"
      />
      <path
        d="M34.191 67.237a2.405 2.405 0 0 1 .438.198c.037.021.072.044.108.067.028.018.057.036.084.056.042.029.082.06.122.093l.066.053c.05.043.097.088.144.135l.02.017.005.007c.213.221.386.484.506.78l.02.047c.022.06.04.12.06.183.003.014.008.027.012.041l.017.056 2.008 8.04a2.452 2.452 0 0 1-1.797 2.977 2.468 2.468 0 0 1-2.983-1.796l-.979-3.92-2.916 2.796c-.98.94-2.537.907-3.48-.068a2.452 2.452 0 0 1 .064-3.476l5.983-5.736c.014-.014.03-.026.045-.04l.02-.017c.242-.217.515-.377.804-.48l.024-.007c.074-.026.149-.05.225-.068l.022-.005c.067-.016.134-.029.202-.038.023-.004.047-.006.07-.009.054-.006.108-.011.162-.014.033-.002.067-.002.1-.003a2.68 2.68 0 0 1 .244.009 2.541 2.541 0 0 1 .58.122Zm-7.374 7.44a.852.852 0 0 0-.02 1.21.868.868 0 0 0 1.222.025l3.577-3.43-.482-1.925-4.297 4.12Zm6.556-1.683 1.201 4.81a.867.867 0 0 0 1.048.628.852.852 0 0 0 .626-1.034l-1.442-5.776-1.433 1.372Zm.307-4.243a.882.882 0 0 0-.12-.032l-.046-.008a.924.924 0 0 0-.08-.007h-.075a.853.853 0 0 0-.065.006l-.024.003c-.027.004-.052.01-.078.016a.85.85 0 0 0-.626 1.033l.361 1.445 1.075-1.03a.852.852 0 0 0-.109-1.319l-.017-.011a.915.915 0 0 0-.05-.03l-.028-.016-.04-.02-.045-.018-.033-.012Z"
        fill="#78B441"
      />
      <path
        d="m92.02 41.58 12.563 18.816a3.832 3.832 0 1 1-6.534 3.994l-11.02-19.76 4.992-3.05Z"
        fill="#007A5F"
      />
      <path d="m95.969 47.493-2.19 9.24-6.75-12.102 4.992-3.051 3.948 5.913Z" fill="#00664F" />
      <path
        d="m95.969 47.493-2.191 9.24-6.749-12.102 4.992-3.051 3.948 5.913Zm-6.794-2.3 3.996 7.165 1.08-4.557-2.708-4.055-2.368 1.447Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.175 45.398c6.385 6.072 16.484 5.819 22.557-.567 6.072-6.384 5.819-16.484-.567-22.556-6.385-6.073-16.484-5.82-22.556.566-6.073 6.386-5.82 16.484.566 22.557Z"
        fill="#78B441"
      />
      <path
        d="M95.314 37.4c-1.788 6.057-8.148 9.517-14.204 7.729-6.057-1.788-9.517-8.148-7.729-14.204 1.789-6.057 8.148-9.517 14.205-7.729 6.056 1.788 9.517 8.148 7.728 14.204Z"
        fill="#E6F4F0"
      />
      <path
        d="M75.164 31.451a9.575 9.575 0 0 1 11.895-6.472.8.8 0 1 1-.453 1.534 7.976 7.976 0 0 0-9.907 5.391.8.8 0 0 1-1.535-.453Z"
        fill="#fff"
      />
      <path
        d="M22.544 43.588a2.73 2.73 0 1 0 5.448-.39 2.73 2.73 0 0 0-5.448.39ZM23.714 59.93a2.73 2.73 0 1 0 5.447-.39 2.73 2.73 0 0 0-5.447.39Z"
        fill="#78B441"
      />
      <path
        d="M26.242 57.012a2.73 2.73 0 0 1 2.904 3.077L24.07 61.1a2.73 2.73 0 0 1 2.171-4.088Z"
        fill="#599F40"
      />
      <path
        d="M32.856 49.968a7.1 7.1 0 0 0-14.163 1.013l.507 7.082 14.163-1.013-.507-7.082Z"
        fill="#78B441"
      />
      <path d="M17.292 46.702a2.73 2.73 0 1 0 5.447-.39 2.73 2.73 0 0 0-5.447.39Z" fill="#FC0" />
      <path
        d="M25.21 42.595a9.034 9.034 0 0 0-1.779.308.8.8 0 0 0 .429 1.542 7.432 7.432 0 0 1 2.951-.212.8.8 0 0 0 .206-1.587 9.041 9.041 0 0 0-1.806-.05Z"
        fill="#0F172A"
      />
      <path
        d="m33.207 54.87-14.163 1.014-.994 1.147a1.93 1.93 0 0 0 1.598 3.19l13.58-.971a1.93 1.93 0 0 0 1.126-3.386l-1.147-.993Z"
        fill="#78B441"
      />
      <path
        d="m32.856 49.968.351 4.903 1.147.993a1.93 1.93 0 0 1-1.127 3.386l-2.976.213.858-.062a1.453 1.453 0 0 0 .848-2.548l-2.018-1.748-7.794.557.915-.279a11.111 11.111 0 0 0 7.838-9.823 7.07 7.07 0 0 1 1.958 4.408Z"
        fill="#599F40"
      />
      <path
        d="M20.621 54.97a.8.8 0 1 0 .114 1.595l10.895-.78a.8.8 0 1 0-.114-1.595l-10.895.78Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocEnableNotifications)
